import { Fragment, useState } from "react";
import Grid from "@mui/material/Grid2";
import { deleteDealerInformation } from "./../../action/deviceDealer";
import { Box, Paper, Stack } from "@mui/material";
import Button from "../Common/Button/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  InfoPairLabel,
  InfoPairValue,
  SectionSubHeading,
} from "../Common/Typography/AppTypography";
import { useDesignTokens } from "../../theme/useDesignTokens";
import Dialog from "../Common/Dailog/Dailog";

const DisplayDeviceDealerDeatils = ({
  deviceDealerDetails,
  displayEditDeleteButton,
  onEditDeviceDealerDetails,
  onDeleteDeviceDealerDetails,
  setAlert,
}) => {
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main;

  const [deleteDeviceDealer, setDeleteDeviceDealer] = useState(false);

  function handleDeleteDeviceDealerFromPopup() {
    deleteDealerInformation(deviceDealerDetails["id"])
      .then((res) => {
        setAlert("Dealer Deleted Sucessfully", "success");
        setDeleteDeviceDealer(false);

        onDeleteDeviceDealerDetails();
      })
      .catch((err) => {
        setAlert(
          err?.response?.data?.message ?? "Failed to Delete Dealer",
          "danger",
        );
        setDeleteDeviceDealer(false);
      });
  }

  return (
    <Fragment>
      <Paper elevation={3} sx={{ p: 2, pl: 3, borderRadius: 2, mt: 1 }}>
        {deviceDealerDetails && Object.keys(deviceDealerDetails).length > 0 && (
          <Fragment>
            {displayEditDeleteButton && (
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Stack direction="row" spacing={4}>
                  <Button
                    startIcon={<EditIcon />}
                    onClick={() =>
                      onEditDeviceDealerDetails(deviceDealerDetails)
                    }
                  >
                    Edit
                  </Button>

                  <Button
                    variant="danger"
                    startIcon={<DeleteIcon />}
                    onClick={() => setDeleteDeviceDealer(true)}
                  >
                    Delete
                  </Button>
                </Stack>
              </Box>
            )}

            <Grid container spacing={4}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ mb: 1 }}>
                  <InfoPairLabel>Dealer ID</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["id"]}</InfoPairValue>
                </Box>
                <Box>
                  <InfoPairLabel>Name</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["name"]}</InfoPairValue>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ mb: 1 }}>
                  <InfoPairLabel>Website</InfoPairLabel>
                  <InfoPairValue>
                    {deviceDealerDetails["website"]}
                  </InfoPairValue>
                </Box>
                <Box>
                  <InfoPairLabel>Email</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["email"]}</InfoPairValue>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <SectionSubHeading sx={{ color: primaryColor, mb: 1 }}>
                  Phone Details
                </SectionSubHeading>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid size={6}>
                    <InfoPairLabel>Number</InfoPairLabel>
                  </Grid>
                  <Grid size={6}>
                    <InfoPairLabel>Type</InfoPairLabel>
                  </Grid>
                </Grid>
                {deviceDealerDetails["phone"]?.map((phone, index) => (
                  <Grid container key={index} spacing={1}>
                    <Grid size={6}>
                      <InfoPairValue>{phone.number}</InfoPairValue>
                    </Grid>
                    <Grid size={6}>
                      <InfoPairValue>{phone.type}</InfoPairValue>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <SectionSubHeading sx={{ color: primaryColor, mb: 1 }}>
                  Location
                </SectionSubHeading>
                <InfoPairLabel>Country</InfoPairLabel>
                <InfoPairValue>{deviceDealerDetails["country"]}</InfoPairValue>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <SectionSubHeading sx={{ color: primaryColor }}>
                  Address
                </SectionSubHeading>
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Line 1</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.line1}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Line 2</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.line2}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>City</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.city}
                    </InfoPairValue>
                  </Box>
                  <Box>
                    <InfoPairLabel>Pincode</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.pincode ||
                        deviceDealerDetails?.address?.pin}
                    </InfoPairValue>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <SectionSubHeading sx={{ color: primaryColor }}>
                  Social Links
                </SectionSubHeading>
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Facebook</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.facebook}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Instagram</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.instagram}
                    </InfoPairValue>
                  </Box>
                  <Box>
                    <InfoPairLabel>X</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.x}
                    </InfoPairValue>
                  </Box>
                </Box>
              </Grid>

              {deleteDeviceDealer && (
                <Dialog
                  open={deleteDeviceDealer}
                  onClose={() => {
                    setDeleteDeviceDealer(false);
                  }}
                  title={"Delete Device Dealer"}
                  actions={[
                    {
                      label: "Cancel",
                      variant: "ghost",
                      onClick: () => {
                        setDeleteDeviceDealer(false);
                      },
                    },
                    {
                      label: "Delete",
                      tooltip: "Click to delete the dealer profile.",
                      variant: "danger",
                      onClick: handleDeleteDeviceDealerFromPopup,
                      slotProps: {
                        popper: {
                          sx: { zIndex: 2400 },
                        },
                      },
                    },
                  ]}
                  sx={{
                    zIndex: 2300,
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: colors?.disabled?.bg,
                      p: 3,
                      borderRadius: 2,
                      textAlign: "left",
                    }}
                  >
                    <SectionSubHeading sx={{ mb: 2 }}>
                      Are you sure you want to delete this dealer profile?
                    </SectionSubHeading>

                    <Box sx={{ mb: 1 }}>
                      <InfoPairLabel>Dealer ID:</InfoPairLabel>
                      <InfoPairValue>{deviceDealerDetails?.id}</InfoPairValue>
                    </Box>
                    <Box>
                      <InfoPairLabel>Name:</InfoPairLabel>
                      <InfoPairValue>{deviceDealerDetails?.name}</InfoPairValue>
                    </Box>
                  </Box>
                </Dialog>
              )}
            </Grid>
          </Fragment>
        )}
      </Paper>
    </Fragment>
  );
};

export default DisplayDeviceDealerDeatils;
